module.exports = __webpack_public_path__ + "static/img/sc.27935c2d.svg";